module.exports = __webpack_public_path__ + "03_veryshort_black.95278f18.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/03_veryshort_black.png
// module id = dfUu
// module chunks = 0